import { render, staticRenderFns } from "./FullDatabaseStatic.vue?vue&type=template&id=7bd45356&scoped=true&"
import script from "./FullDatabaseStatic.vue?vue&type=script&lang=js&"
export * from "./FullDatabaseStatic.vue?vue&type=script&lang=js&"
import style0 from "./FullDatabaseStatic.vue?vue&type=style&index=0&id=7bd45356&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd45356",
  null
  
)

export default component.exports